import { Middleware } from "openapi-fetch";
import { ApiAuth } from "./auth";

export function createAuthMiddleware(auth: ApiAuth): Middleware {
  return {
    async onRequest({ request }) {
      const accessToken = await auth.getToken();
      request.headers.set("Authorization", `Bearer ${accessToken}`);
      return request;
    },
  };
}
